import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthService } from './api/auth.service';
import { ApiService } from './services/api.service';
import { Configuration } from '../app.constants';
import { Interceptor } from './interceptors/interceptor';
import { IdempotencyInterceptor } from './interceptors/idempotency.interceptor';
import { TransactionService } from './api/transaction.service';
import { NetworkMemberService } from './api/network-member.service';
import { IdempotencyKeyService } from './services/idempotency-key.service';

@NgModule({
  imports: [CommonModule, HttpClientModule],

  declarations: [],

  providers: [
    ApiService,
    AuthService,
    TransactionService,
    NetworkMemberService,
    IdempotencyKeyService,

    Configuration,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdempotencyInterceptor,
      multi: true,
    },
  ],
  exports: [],
})
export class CoreModule {}
